define('uikit/views/form.wrapper',['require','exports','module','underscore','../collections/form','../collections/container','../channel','../elements/button','../elements/text'],function(require, exports, module){
  var _ = require('underscore');
  var FormView = require('../collections/form');
  var ContainerView = require('../collections/container');
  var channel = require('../channel');
  var ButtonView = require('../elements/button');
  var TextView = require('../elements/text');

  var ConfirmButtonOptions = {
    color: 'blue',
    icon: 'check'
  };

  var CloseButtonOptions = {
    icon: 'remove'
  };

  var PlaceholderText = TextView.extend({

    tagName: 'div',

    template: function(props) {
      return props.text + '<i class="icon ' + props.icon + '"></i>';
    },

    options: _.extend({}, TextView.prototype.options, {
      visible: false,
      icon: 'pencil'
    }),

    forceUpdate: { icon: true },

    triggers: {
      'click' : 'press'
    },

    events: {
      'keydown' : function(ev) {
        if (ev.keyCode == 13) { this.triggerMethod('press'); }
      }
    },

    onRender: function() {
      if (this.getOption('parent').getOption('editable')) {
        this.$el.prop('tabindex', 0);
      } else {
        this.$el.removeAttr('tabindex');
      }
    }

  });

  var FormWrapper = FormView.Field.extend({

    options: _.extend({}, FormView.Field.prototype.options, {
      active        : false,
      valueBinding  : 'value',
      textBinding   : null,
      saveOnBlur    : false,
      closeOnBlur   : true,
      textOnBlur    : true,

      buttonGroup   : null,
      confirmButton : null,
      closeButton   : null,
      
      textView      : null,
      editable      : true,
      editing       : false,
      input         : null,
      fluid         : false,
      model         : null
    }),

    forceUpdate: {
      valueBinding: true,
      textBinding: true,
      textOnBlur: true,
      buttonGroup: true,
      confirmButton: true,
      closeButton: true,
      textView: true,
      editable: true,
      input: true,
      model: true
    },

    initialize: function() {
      FormView.Field.prototype.initialize.apply(this, arguments);

      this.setupChildrenViews();
      this._updateEditingProperties();
    },

    onFirstRender: function() {
      this.listenTo(this.input, 'change:value', function() {

      })
      // beging listen for changes on view
      // now that its rendered
      this
          .on('change:editing change:disabled change:editable', _.debounce(function() {
            // update internal view properties since our
            // editing, disabled, or editable options have changed
            this._updateEditingProperties();
          }))
          .on('change:input', function(self, newInput, oldInput) {
            // whoa...we got a new input...
            // rebind and set it up
            if (oldInput) {
              this.stopListening(oldInput);
            }
            this._updateInputSetup();
            this._updateEditingrPoperties();
          });

      // setup all the listeners on the input
      this._updateEditingProperties();
      this._updateInputSetup();
    },

    _updateEditingProperties: function() {
      var editable = this.editable && !this.disabled;

      this.$el.toggleClass('editing', this.editing);

      this.buttonGroup.visible = this.editing && editable;

      this.textView.visible = this.textOnBlur && !this.editing;

      if (this.input) {
        this.input.visible = !this.textOnBlur || this.editing;

        this.input.disabled = !this.editable || this.disabled;

        if (this.editing) {
          if (this.input.isRendered) {
            this.input.focus();
          }
        }
      }
      // add useful events for knowing when editing begins and ends
      if (this.editing) {
        this.triggerMethod('begin:edit');
      } else {
        this.triggerMethod('end:edit');
      }
    },

    onChangeModel: function(self, model, oldModel) {
      if (oldModel) {
        this.stopListening(oldModel);
      }

      this.textView.model = this.model;

      this._updateModelListeners();
    },

    _updateModelListeners: function() {
      // Remove any previous listeners for previous input
      if (this.model) {
        this.stopListening(this.model);
      }

      // Create listener on model
      if (this.model) {

        if (this.input) {
          this.listenTo(this.model, 'change:' + this.valueBinding, function() {
            this.input.value = this.model.get(this.valueBinding);
          });

          this.input.value = this.model.get(this.valueBinding);
        }

        this.listenTo(this.model, 'sync', function() {
          this._ignoreBlur = false;
          this._oldValue = null;
          if (this.closeOnBlur) {
            this.editing = false;
          }
        });
      }
    },

    _updateInputSetup: function() {
      this.removeChildrenListeners();

      if (this.input) {
        this.add(this.input, { at: 0 });

        this.setupListeners();
      }

      this._updateModelListeners();
    },

    setupChildrenViews: function() {
      this.confirmButton = new ButtonView(_.extend({}, ConfirmButtonOptions));
      this.closeButton = new ButtonView(_.extend({}, CloseButtonOptions));
      this.textView = new PlaceholderText();

      this.textView.model = this.model;
      this.textView.bindings.text = this.textBinding || this.valueBinding;

      this.buttonGroup = new ContainerView({ className: 'ui buttons'})
          .add(this.confirmButton)
          .add(this.closeButton)

      this.add(this.buttonGroup)
          .add(this.textView)
    },

    onChangeValueBinding: function() {
      this.textView.bindings.text = this.textBinding || this.valueBinding;
      if (this.input) {
        this.input.bindings.value = this.valueBinding;
      }
    },

    onChangeTextBinding: function() {
      this.textView.bindings.value = this.textBinding || this.valueBinding;
    },

    removeChildrenListeners: function() {
      this.stopListening(this.confirmButton);
      this.stopListening(this.closeButton);
      this.stopListening(this.textView);
    },

    setupListeners: function() {
      this
        .listenTo(this.input, 'enter', function() {
          if (!this.input.multiLine) {
            this._ignoreBlur = true;

            this.setInputValue();
          }
        })
        .listenTo(this.input, 'escape', function() {
          this.resetInputValue();
        })

      this.listenTo(this.input, 'focus', function() {
        this.editing = true;
      });

      this.listenTo(this.input, 'blur', function() {
        if (!this._ignoreBlur) {
          if (this.saveOnBlur) {
            this.setModelValue();
          } else if (this.closeOnBlur) {
            this.resetInputValue();
          }
        }
      });

      this.listenTo(this.confirmButton, 'before:press', function() {
        this._ignoreBlur = true;
        this.setInputValue();
      });

      this.listenTo(this.confirmButton, 'press', function() {
        this._ignoreBlur = false;
      });

      this.listenTo(this.closeButton, 'before:press', function() {
        this.resetInputValue();
      });

      this.listenTo(this.textView, 'press', function() {
        if (this.editable && !this.disabled) {
          this.triggerMethod('before:begin:edit');
          this.editing = true;
        }
      });
    },

    setModelValue: function() {
      this._oldValue = null;

      this.model.set(this.valueBinding, this.input.value);
    },

    setInputValue: function() {
      if (!this._oldValue) {
        this._oldValue = this.model.get(this.valueBinding);
      }

      this.model.set(this.valueBinding, this.input.value);

      this.triggerMethod('confirm');
    },

    resetInputValue: function() {
      this.editing = false;

      if (this._oldValue) {
        this.model.set(this.valueBinding, this._oldValue);
      } else {
        this.input.value = this.model.get(this.valueBinding);
      }

      this._oldValue = null;

      this.triggerMethod('close');
    },

    updateAttributes: function() {
      FormView.Field.prototype.updateAttributes.apply(this, arguments);

      this
          .addClass('active', this.getBoolOption('active'))
          .addClass('editable', this.getBoolOption('editable') && !this.getBoolOption('disabled'))
          .addClass('fluid', this.getBoolOption('fluid'))
    }

  });

  channel.reply('form-wrapper', function() {
    return FormWrapper;
  });  

  module.exports = FormWrapper;
  
});
